import { render } from "./WishlistView.vue?vue&type=template&id=7410cb8e&scoped=true"
import script from "./WishlistView.vue?vue&type=script&lang=js"
export * from "./WishlistView.vue?vue&type=script&lang=js"

import "./WishlistView.vue?vue&type=style&index=0&id=7410cb8e&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-7410cb8e"]])

export default __exports__